<section id="main-section">
    <div class="w-100 full-wdth-note-bookmarks">
        <div class="d-flex notes__bookmarks--banner">
            <div class="notes__bookmarks--banner-inner">
                <div>
                    <h3>
                        Notes and Bookmarks
                    </h3>
                    <p>Notes for quick revisions</p>
                </div>
                <div>
                    <img src="./../../../../assets/images/upgradRed/upgradNandBLogo.png" alt="Notes and Bookmarks">
                </div>
            </div>
        </div>
        <article class="notes__bookmarks">

            <div class="notes__bookmarks--wrap">
                <!-- Tab links -->
                <div class="notes__bookmarks--tab">
                    <button class="tablinks cursor-pointer border-none outline-none active"
                        (click)="openTab($event, 'tabNotes')">Your Notes</button>
                    <button class="tablinks cursor-pointer border-none outline-none"
                        (click)="openTab($event, 'tabBookmarks')">Your Bookmarks</button>
                </div>
                <!-- <hr class="notes__bookmarks--hr border-none"> -->
                <!-- Tab content -->
                <div [ngStyle]="{'overflow':filterNotes.length == 0 ?'hidden':'auto'}" id="tabNotes" class="notes__bookmarks--tabcontent active" style="display: flex;">
                    <div class="accordion__wrapper">
                        <div class="empty-note-bookmarks" *ngIf="!filterNotes.length">
                            <img src="./../../../../assets/images/upgradRed/upgradNandBLogoEmpty.png" alt="No Notes">
                            <p>Sorry, there are no notes available.</p>
                        </div>
                        <div [ngClass]="{'open--accordion': item.collapse, 'close--accordion': !item.collapse}"
                            *ngFor="let item of filterNotes; let i=index" class="accordion__item open--accordion">
                            <div (click)="item.collapse = !item.collapse"
                                class="accordion__item--header d-flex align-items-center cursor-pointer accordion__item--header-notes">
                                <div class="accordion__item--header--title  text-capitalize">
                                    {{item.courseTitle | titlecase}}
                                    <span class="accordion__item--notes--no grey-color">
                                        {{item.notes.length}} Notes</span>
                                </div>
                                <div class=" d-flex align-items-center justify-content-between">
                                    <span class="material-symbols-outlined acc-icon">
                                        expand_more
                                    </span>
                                    <!-- <img src="assets/images/Icon-up.svg" width="14" height="20" alt=""
                                        class="mg-l30 acc-icon"> -->
                                </div>
                            </div>
                            <div class="accordion__item--content" *ngFor="let modules of item.modules; let i=index">
                                <div
                                    class="d-flex align-items-center mg-b15 justify-content-between accordion__item--content--top">
                                    <div class="accordion__item--content--title dark-color text-capitalize">
                                        {{modules.moduleName}}</div>
                                    <!-- <div class="accordion__item--content--hr"></div> -->
                                </div>
                                <div class="accordion__item--card-wrap">
                                    <div class="accordion__item--card" *ngFor="let note of modules.notes; let i=index">
                                        <h5> Note {{i+1}}</h5>
                                        <p class="accordion__item--content--subtitle">{{note.title}},
                                            <span> {{(note.recordedTime > 0) ? transform(note.recordedTime) :''}}</span>
                                        </p>
                                        <p class="accordion__item--content--desc">{{note.description}}</p>


                                        <div class="accordion__item--buttons cursor-pointer">
                                            <a (click)="navigateToPlayer(note)">Refer back</a>
                                            <a (click)="deleteNote(note)"><span class="material-symbols-outlined">
                                                    delete
                                                </span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="tabBookmarks" class="notes__bookmarks--tabcontent">
                    <div class="accordion__wrapper">
                        <div class="empty-note-bookmarks" *ngIf="!filterBookmarks.length">
                            <img src="./../../../../assets/images/upgradRed/upgradNandBLogoEmpty.png" alt="No Notes">
                            <p>Sorry, there are no bookmarks available.</p>
                        </div>
                        <div class="accordion__item open--accordion"
                            [ngClass]="{'open--accordion': item.collapse, 'close--accordion': !item.collapse}"
                            *ngFor="let item of filterBookmarks; let $index=index;">
                            <div (click)="item.collapse = !item.collapse"
                                class="accordion__item--header d-flex align-items-center justify-content-between cursor-pointer accordion__item--header-bookmarks">
                                <div class="accordion__item--header--title text-capitalize">
                                    {{item.courseTitle | titlecase}}
                                    <span class="accordion__item--notes--no">
                                        {{item.notes.length}} bookmarks</span>
                                </div>
                                <div class=" d-flex align-items-center justify-content-between">
                                    <span class="material-symbols-outlined acc-icon">
                                        expand_more
                                    </span>
                                </div>
                            </div>
                            <div class="accordion__item--content" *ngFor="let modules of item.modules; let i=index">
                                <div
                                    class="d-flex align-items-center mg-b15 justify-content-between accordion__item--content--top">
                                    <div class="accordion__item--content--title dark-color text-capitalize">
                                        {{modules.moduleName}}</div>
                                    <!-- <div class="accordion__item--content--hr"></div> -->
                                </div>
                                <div class="accordion__item--card-wrap">
                                    <div class="d-flex dark-color accordion__item--content--video cursor-pointer accordion__item--card"
                                        (click)="navigateToPlayerBookmarks(bboks.mediaType, bboks.content, bboks.course)"
                                        *ngFor="let bboks of modules.notes; let i=index">
                                        <h5>Bookmark {{i+1}}</h5>
                                        <p class="accordion__item--content--subtitle">{{bboks.title}}
                                            <!-- <span>{{transform(bboks.duration)}}</span> -->

                                        </p>
                                        <div class="accordion__item--buttons cursor-pointer mg-t20">
                                             <!--  <p class="mg-l10">{{bboks.mediaType == 'VIDEO_LIST' ? 'Video' :
                                                bboks.mediaType
                                                }}
                                            </p> -->
                                            <button class="accordion__item--player">
                                                <img src="assets/images/upgradRed/play_arrow.png" alt="">
                                                Show in Player
                                            </button>
                                            <span class="video--duration">Duration: {{transform(bboks.duration)}}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="" *ngFor="let bboks of modules.notes; let i=index">
                                <p class="accordion__item--content--desc mg-b10">{{bboks.title}}</p>
                                <img src="assets/images/play.svg" alt=""> {{bboks.mediaType}}

                                <p class="accordion__item--content--subtitle grey-color mg-b10">
                                    {{transform(bboks.duration)}}</p>
                            </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- FourEyes Embed -->
                <!-- <div class="foureyes-embed" data-survey="8xp4f" data-width="700" data-height="333"></div> -->
                <!-- /FourEyes Embed -->
            </div>
        </article>
    </div>
</section>
<app-common-loader *ngIf="isLoader"></app-common-loader>
